export default __webpack_public_path__ + "static/media/user_card.9cebb224.jpg";